import styled from 'styled-components'

import { IconButton, Info, ResponsiveImage, TypeStyleBodySmall } from '@syconium/little-miss-figgy'

import { useCart } from '../../../../../app/_providers/CartProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'

import { useAffirm } from './scripts/AffirmSdk'

// Rendered only when the Affirm experiment is active (see `MiniCartContent` / `useAffirmExperiment`).
export const AffirmPromo = () => {
  const {
    affirm: { minicartMessageTemplate },
    magnolia: {
      general: { learnMore },
    },
  } = useTranslation()
  const {
    cart: { totalPrice },
  } = useCart()
  useAffirm({ totalPrice })

  // For cart totals >= $100 and < $300, use 4 portions
  let paymentsCount: number | undefined = 4

  // for cart totals >= $300, use 3 portions
  if (totalPrice >= 30000) {
    paymentsCount = 3
  }

  const promoCopy = minicartMessageTemplate.replace('{{count}}', paymentsCount.toString())

  return (
    <>
      <PromoWrapper>
        <CopyWrapper>
          <TypeStyleBodySmall>
            {promoCopy}{' '}
            <InlineAffirmLogo>
              <ResponsiveImage
                src='https://images.ctfassets.net/5j6wpslh72e4/7aH3UGi6TN15ct5kGjSLg2/ea2cc21ea231e272beb5cf50c301c1ec/affirm-logo-mono-black.png'
                aspectRatios={{ md: 41 / 16.34, sm: 41 / 16.34 }}
                alt='Affirm'
                loading='default'
                widths={{ unit: 'px', md: 42, sm: 42 }}
                transparentBackground
              />
            </InlineAffirmLogo>
          </TypeStyleBodySmall>
        </CopyWrapper>
        <LearnMoreButton
          type='button'
          aria-label={learnMore}
          aria-haspopup='dialog'
          className='affirm-product-modal'
          data-page-type='cart'
          data-amount={totalPrice}
        >
          <Info width={16} height={16} aria-hidden />
        </LearnMoreButton>
      </PromoWrapper>
    </>
  )
}

const PromoWrapper = styled.div`
  display: flex;
  align-items: center;
`

const CopyWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${o => o.theme.rowGap.tiny};
  padding-right: ${o => o.theme.spacing(1)};
`

const InlineAffirmLogo = styled.span`
  display: inline-block;
`

const LearnMoreButton = styled(IconButton)`
  min-height: 24px;
  min-width: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};

  &:hover {
    background-color: unset;
  }
`
